import React from "react";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import SplitText from "gsap/SplitText";
import "./style.css";
import { Images } from "../../utils/constant";

gsap.registerPlugin(SplitText, useGSAP);

const Intro = () => {
  useGSAP(() => {
    document.body.style.overflow = "hidden";
    const text = new SplitText(".intro-text", { type: "chars" });

    const tl = gsap.timeline({
      defaults: { ease: "power3.out" },
      onComplete: () => {
        // ✅ Re-enable scroll after animation finishes
        document.body.style.overflow = "auto";
      },
    });

    // Entrance animation
    tl.from(text.chars, {
      autoAlpha: 0,
      yPercent: "random([-50, 50])",
      rotationX: "random([-30, 30])",
      scale: 1.2,
      yoyo: true,
      repeat: -1,
      duration: 0.8,
      ease: "back.out(1.7)",
      stagger: {
        amount: 0.6,
        from: "center",
      },
    });
    tl.to(".intro-container", {
      duration: 1.5,
      delay: 0.5, // Delay before the exit animation starts
      y: "-100vh",
      ease: "power3.inOut",
      onComplete: () => {
        gsap.set(".intro-container", { autoAlpha: "0", display: "none" });
        document.body.style.overflow = "auto"; // Re-enable scroll after exit
      },
    });
  });

  return (
    <div className="intro-container">
      <img
        src={Images.logoIcon}
        alt="dive buddies logo"
        className="intro-logo-icon"
      />
      <h1 className="intro-text">DiveBuddies</h1>
    </div>
  );
};

export default Intro;
